module.exports = __webpack_public_path__ + "assets/08e8fa90c02037350b8e8c7425075a2a.png";